const environment = getEnvironment();

let API_URL = "https://api.querco.co"; // TODO: REMOVE beta. before merging
let SentryUrl = "https://54d86cd302e37ec6ce53fe1e30aae07b@o4510783176966144.ingest.de.sentry.io/4510783199576144";
let APP_URL = "https://admission.b2a.fr"; // TODO: Change to app.querco.co

if (environment === "development") {
  API_URL = import.meta.env.VITE_DEV_API_URL || "http://localhost:8080";
  // APP_URL = "http://localhost:8082";
}

export { API_URL, SentryUrl, environment, APP_URL };

function getEnvironment() {
  if (window.location.href.indexOf("localhost") !== -1 || window.location.href.indexOf("127.0.0.1") !== -1) {
    return "development";
  }
  return "production";
}
